export default __webpack_public_path__ + "static/media/news-12.87c4d87f.jpg";